<div class="container-upload">
  <button [disabled]="disabled" [ngClass]="{'disabled': disabled}" class="button upload" (click)="inputFile.click()">بارگذاری</button>
  <input
    name="file"
    id="file"
    (change)="upload($event, 'logo')"
    type="file" #inputFile hidden>
</div>
